import { Col } from 'components/Col';
import { CustomNumberField } from 'components/CustomNumberField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import { getOnlyNumbers } from 'utils/DataFormatUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.quantidadeAlunosTurma;
export default function QuantidadeCriancasAdolescentes() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'quantidadeAlunosTurma',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  return (
    <Row>
      <Col>
        <CustomNumberField
          onlyInteger={true}
          onlyPositive={true}
          label={language.label}
          placeholder={language.placeholder}
          name='quantidadeAlunosTurma'
          inputMode='numeric'
          value={state.projeto.quantidadeAlunosTurma || ''}
          maxLength={4}
          max={9999}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                quantidadeAlunosTurma: evt.target.value
                  ? parseInt(getOnlyNumbers(evt.target.value))
                  : undefined,
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
